<template>
  <div class="inside">
    <div class="container-fluid" id="boxes-wrapper">
      <div class="row flex">
        <template v-for="(box, index) in boxes">
          <div
            class="box-wrapper new col-sm-4 col-xs-12"
            :key="index"
            v-if="index < boxlimit && !showModal"
          >
            <div
              class="box"
              :id="'b' + index"
              v-in-viewport="{}"
              @click.prevent="openModal(box)"
            >
              <div
                class="mask-video gtm_Content-expand"
                v-if="box.elements.thumbnail_video.value && !$breakpoints.isMobile()"
                @mouseover="hoverVideo($event)"
                @mouseleave="leaveVideo($event)"
                v-bind:style="{
                  'background-image':
                    'url(' + box.elements.thumbnail_image.value[0].url + ')',
                }"
              >
                <video
                  loop
                  playsinline
                  muted
                  preload="metadata"
                  onloadedmetadata="this.muted = true"
                  class="o-fit gtm_Content-expand"
                >
                  <source :src="box.elements.thumbnail_video.value" type="video/mp4" />
                </video>
              </div>
              <div
                class="mask-image gtm_Content-expand"
                v-else
                v-bind:style="{
                  'background-image':
                    'url(' + box.elements.thumbnail_image.value[0].url + ')',
                }"
              ></div>
            </div>

            <div class="box-info">
              <h3 class="box-client-name">{{ box.elements.client.value[0].name }}</h3>
              <h2 class="box-title">{{ box.elements.header_title.value }}</h2>
            </div>
          </div>
        </template>
      </div>

      <template v-if="boxes.length > boxlimit">
        <div
          v-if="$route.path == '/inclusion/case-studies'"
          class="load-more-container text-center col-xs-12"
        >
          <button class="btn_orange" @click="boxlimit += 8">LOAD MORE</button>
        </div>
      </template>
      <div v-if="showViewAll" class="load-more-container text-center col-xs-12">
        <router-link to="/inclusion/case-studies" tag="button" class="btn_orange"
          >VIEW ALL</router-link
        >
      </div>
    </div>
  </div>
</template>
<script>
import porfolio from "../components/porfolio.vue";
import apiConnection from "../mixins/apiConnection.js";

export default {
  name: "boxesWrapperInclusion",
  props: ["boxes", "boxlimit", "search", "showViewAll", "modularContent"],
  components: {
    porfolio: porfolio,
  },
  data() {
    return {
      showModal: false,
      modalData: [],
      solutions: [],
      configs: {
        orderBy: "",
        order: "desc",
        filter: "",
      },
      arrVideos: [],
      fbUrl: "",
      twUrl: "",
      LinInUrl: "",
      mailContent: "",
      shareTitle: "",
    };
  },
  methods: {
    hoverVideo: function ($event) {
      setTimeout(function () {
        $event.target.play();
      }, 1500);
      $(".mask-video video").addClass("no-transform");
      $(".mask-video").prev().addClass("fade-out-title");
      $(".mask-video").siblings(".overlay-gradient").addClass("fade-out-title");
    },
    leaveVideo: function ($event) {
      $event.target.firstChild.pause();
      $event.target.firstChild.currentTime = 0;
      $(".mask-video video").removeClass("no-transform");
    },
    gotoCase: function (data) {
      var id = data.elements.url.value;
      this.$router.push({ path: "/inclusion/case-studies/" + id });
      window.scrollTo(0, 0);
      window.location.href = "/inclusion/case-studies/" + id;
      //window.location.reload()
    },

    openModal: function (box) {
      this.showModal = !this.showModal;

      var id = box.elements.url.value;
      //this.$router.push({ path: '#' + id });
      this.$router.push({ path: "/inclusion/case-studies/" + id });
      window.scrollTo(0, 0);
      window.location.href = "/inclusion/case-studies/" + id;

      this.$gtm.trackEvent({
        event: "click", // Event type [default = 'interaction'] (Optional)
        category: id,
        action: "click",
        label: "Works",
        noninteraction: false, // Optional
      });

      let v_sliders = box.elements.slider_video.value;
      //let flag = false;
      box.elements.arrVideos = [];

      box.elements.case_study_short_description.value = this.escapeHtmlEntities(
        box.elements.case_study_short_description.value
      );

      setTimeout(function () {
        var m = $(".modal-work-content");
        var x = $(".VueCarousel-dot-container", m).width();
        $(".VueCarousel-navigation-prev", m).css(
          "left",
          "calc(50% - " + (x / 2 + 20) + "px )"
        );
        $(".VueCarousel-navigation-next", m).css(
          "right",
          "calc(50% - " + (x / 2 + 20) + "px )"
        );

        if ($(".VueCarousel-dot-container", m).children().length < 2) {
          $(".VueCarousel-navigation", m).hide();
        } else {
          $(".VueCarousel-navigation", m).show();
        }
      }, 100);

      // if (v_sliders.length) {
      //   for (var slide in v_sliders) {
      //     if (this.modularContent.hasOwnProperty(v_sliders[slide])) {
      //       this.arrVideos.push(this.modularContent[v_sliders[slide]].elements);
      //       // flag = true;
      //       this.getVideoSlider(v_sliders);
      //     }
      //   }
      // }

      box.elements.video_slider = this.arrVideos;

      this.modalData = box;

      if (box.elements.solutions.value.length) {
        let solutions = box.elements.solutions.value;
        for (var i = 0; i < solutions.length; i++) {
          this.getSolutionById(solutions[i]);
        }
      }

      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        document.querySelector(".load-more-container > button").style.display = "none";
      }

      if (this.$route.path == "/inclusion/case-studies")
        var ele = document.getElementById("boxes-wrapper");
      else if (this.$route.path == "/") var ele = document.getElementById("section");

      if (this.$breakpoints.isMobile()) {
        if (this.$route.path == "/inclusion/case-studies")
          window.scrollTo(0, ele.offsetTop - 20);
        else if (this.$route.path == "/") window.scrollTo(0, ele.offsetTop);
      } else {
        if (this.$route.path == "/inclusion/case-studies")
          window.scrollTo(0, ele.offsetTop - 30);
        else if (this.$route.path == "/") window.scrollTo(0, ele.offsetTop + 40);
      }
    },
    closeModal: function () {
      this.showModal = false;
      this.solutions = [];
      this.arrVideos = [];

      window.history.pushState(null, null, window.location.href.split("#")[0]);

      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        document.querySelector(".load-more-container > button").style.display = "";
      }
    },
  },
  mixins: [apiConnection],
};
</script>



// WEBPACK FOOTER //
// boxes-wrapper-inclusion.vue?67bca29a